export interface SpsOptionListOptionConfig {
    textKey?: string;
    text?: string;
    captionKey?: string;
    caption?: string;
    disabled?: boolean;
}

export class SpsOptionListOption<T> {
    textKey: string;
    captionKey: string;

    constructor(public value: T, config: SpsOptionListOptionConfig = {}) {
        Object.assign(this, config);
    }

    private _text: string;
    get text() {
        if (this._text) {
            return this._text;
        }
        if (!this.value) {
            return "";
        }
        return this.textKey ? this.value[this.textKey] : this.value.toString();
    }
    set text(value: string) {
        this._text = value;
    }

    private _caption: string;
    get caption() {
        if (this._caption) {
            return this._caption;
        }
        if (!this.value) {
            return "";
        }
        return this.captionKey ? this.value[this.captionKey] : "";
    }
    set caption(value: string) {
        this._caption = value;
    }

    getHtml(patternToUnderline?: RegExp) {
        if (patternToUnderline) {
            return this.text.replace(patternToUnderline, "<u>$&</u>");
        }
        return this.text;
    }

    get href() {
        if (this.value) {
            return this.value["isLink"] && typeof this.value === "function"
                ? (this.value as any)()
                : this.value["href"];
        }
    }

    private _disabled: boolean;
    get disabled() {
        if (typeof this._disabled !== "undefined") {
            return this._disabled;
        }
        return this.value ? this.value["disabled"] : false;
    }
}
